import React, {useEffect, useState} from 'react';
import {Button} from "react-bootstrap";
import {RegisterBackgroud, BoxLayout, BoxRegister, LoginRuler, HaveAcount} from './style';
import {useDispatch, useSelector} from 'react-redux';
import { userRegister } from '../../_store/_actions/repositoryUserActions';
import validator from 'validator';
import {AlertError} from "../Login/style";
import {hideBookingBar, removeError, setError} from "../../_store/_actions/uiActions";
import {Link} from "react-router-dom";
import ReactLoading from 'react-loading';

const RegisterPage = (props) => {

    const dispatch = useDispatch();
    const { msgError, loading } = useSelector(state => state.ui);
    const [isLoading, setIsLoading] = useState(false);

    const [user, setUser] = useState({
        FirstName: '',
        LastName: '',
        Email: '',
        UserName: '',
        Password: '',
        ConfirmPassword: ''
    })

    const insertValues = e => {
        const {name, value} = e.target;
        setUser( ant => ({
            ...ant,
            [name]: value
        }))
    }

    const handleRegister = e => {
        e.preventDefault();

        if (isFormValid()) {
            setIsLoading(true);
            dispatch(userRegister(user)).then( (response) => {
               setIsLoading(false);
               if (response.status === 200) {
                   props.history.push("/membership");
               }
            }).catch( error => {
                setIsLoading(false);
            });
        }
    }

    const isFormValid = () => {

        if (user.FirstName.trim().length === 0) { dispatch(setError('First name is required!')); return false};
        if (user.LastName.trim().length === 0) { dispatch(setError('Last name is required!')); return false};
        if (!validator.isEmail(user.Email)) { dispatch(setError('Email is invalid!')); return false};
        if (user.UserName.trim().length === 0) { dispatch(setError('User name is required!')); return false};
        if (user.Password.trim().length === 0) { dispatch(setError('Password is required!')); return false};
        if (user.ConfirmPassword.trim().length === 0) { dispatch(setError('Confirm password  is required!')); return false};
        if (user.Password !== user.ConfirmPassword || user.Password < 8)
            { dispatch(setError('Password are different or less than 8 characters!')); return false};

        return true;
    }

    useEffect(() => {
        dispatch(removeError());
        dispatch(hideBookingBar());
    },[])

    return (
        <>
            <RegisterBackgroud>
                <BoxLayout className="noradius nomargin noborder col-md-5">

                    {
                        isLoading &&
                        <ReactLoading className="loading" type="spin" color="#143899" height={'80px'} width={'80px'} />
                    }

                    <BoxRegister>

                        <div className="logo" />

                        {
                            msgError &&
                            <AlertError>
                                {msgError}
                            </AlertError>
                        }

                        <form id="register-form" name="register-form" className="nobottommargin pt-3" onSubmit={ handleRegister }>

                            <div className="col_half">
                                <label htmlFor="register-form-email">First Name:</label>
                                <input type="text" id="FirstName"
                                       name="FirstName"
                                       value={user.FirstName}
                                       onChange={ insertValues }
                                       className="form-control"/>
                            </div>

                            <div className="col_half col_last">
                                <label htmlFor="register-form-email">Last Name:</label>
                                <input type="text" id="LastName"
                                       name="LastName"
                                       value={user.LastName}
                                       onChange={ insertValues }
                                       className="form-control"/>
                            </div>

                            <div className="col_full">
                                <label htmlFor="register-form-email">Email:</label>
                                <input type="text" id="Email"
                                       name="Email"
                                       value={user.Email}
                                       onChange={ insertValues }
                                       className="form-control"/>
                            </div>

                            <div className="col_full">
                                <label htmlFor="register-form-username">Username:</label>
                                <input type="text" id="UserName"
                                       name="UserName"
                                       value={user.UserName}
                                       onChange={ insertValues }
                                       className="form-control"/>
                            </div>

                            <div className="col_half">
                                <label htmlFor="register-form-password">Password:</label>
                                <input type="password" id="Password"
                                       name="Password"
                                       value={user.Password}
                                       onChange={ insertValues }
                                       className="form-control"/>
                            </div>

                            <div className="col_half col_last">
                                <label htmlFor="register-form-repeat-password">Confirm Password:</label>
                                <input type="password" id="ConfirmPassword"
                                       name="ConfirmPassword"
                                       value={user.ConfirmPassword}
                                       onChange={ insertValues }
                                       className="form-control"/>
                            </div>

                            <LoginRuler className="col_full">
                                <div className="col_half">
                                    <ul>
                                        <li>One lowercase character</li>
                                        <li>One uppcase character</li>
                                        <li>One number</li>
                                    </ul>
                                </div>
                                <div className="col_half col_last">
                                    <ul>
                                        <li>One special cheracter</li>
                                        <li>8 cheracters minimun</li>
                                    </ul>
                                </div>
                            </LoginRuler>

                            <div className="col_full nomargin nopadding">
                                <div className="col_one_third">
                                    <Button type="submit" className="button button-3d button-black nomargin"
                                            id="register-form-submit"
                                            name="register-form-submit"
                                            disabled={ loading }
                                    >
                                        Sign Up
                                    </Button>
                                </div>
                            </div>

                            <div className="col_full">
                                <HaveAcount>
                                    <p>- Already have an account? <Link to="/login">Log In</Link></p>
                                </HaveAcount>
                            </div>

                        </form>

                        <footer className="blockquote-footer col_full">Clicking the "Sign Up" button you are creating a
                            Shared Economy account and you agree to Shared Economy's
                        </footer>

                    </BoxRegister>
                </BoxLayout>
            </RegisterBackgroud>
        </>
    )
}

export default RegisterPage;